import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_CERTIFICATION_PARAM, CANDIDATE_CERTIFICATIONS, CANDIDATE_DETAILS_BY_PARAM } from "../../../common/URLs";


export const fetchCertifications = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_CERTIFICATION_PARAM}`; // Proxy path
  try {
    const token = await fetchToken();
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addCertification = async (newCertification) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_CERTIFICATIONS}`; // Proxy path
  try {
    const token = await fetchToken();
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newCertification),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteCertification = async (uuid) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_CERTIFICATIONS}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        "Error deleting job certification: " + response.statusText
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job certification: " + error.message);
  }
};

export const updateCertification = async (uuid, certificateData) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_CERTIFICATIONS}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(certificateData),
    });

    // console.log("certificateData", certificateData);

    if (!response.ok) {
      throw new Error("Error updating job title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job title: " + error.message);
  }
};
